import React from 'react';
import PropTypes from 'prop-types';

import Card from './card';

const ListLinks = ({ children, className }) => (
  <Card className={`bvs-list-links ${className}`}>
    <ul>{children}</ul>
  </Card>
);

ListLinks.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ListLinks.defaultProps = {
  className: null,
};

export default ListLinks;
